import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { PortalSettingsResponse } from "../contracts/PortalSettingsResponse";
import { UpdatePortalSettingsRequest } from "../contracts/UpdatePortalSettingsRequest";

export const fetchPortalSettings = createAsyncThunk<
  PortalSettingsResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("portalSettings/fetch", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<PortalSettingsResponse>("/portal-settings");
    return response.data;
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to load portal settings"));
  }
});

export const updatePortalSettings = createAsyncThunk<
  PortalSettingsResponse,
  UpdatePortalSettingsRequest,
  { rejectValue: ApiErrorResponse }
>("portalSettings/update", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put<PortalSettingsResponse>("/portal-settings", request);
    return response.data;
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to save portal settings"));
  }
});
